var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmokingAndVaping = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Allowances-Smoking--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Allowances Smoking Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.5A1.5 1.5 0 0 0 24 18v-4a1.5 1.5 0 0 0 -1.5 -1.5h-18A1.5 1.5 0 0 0 3 14v4a1.5 1.5 0 0 0 1.5 1.5ZM5 15a0.5 0.5 0 0 1 0.5 -0.5H17a0.5 0.5 0 0 1 0.5 0.5v2a0.5 0.5 0 0 1 -0.5 0.5H5.5A0.5 0.5 0 0 1 5 17Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 13A1.5 1.5 0 0 0 0 14.5v3A1.5 1.5 0 0 0 1.5 19a0.5 0.5 0 0 0 0.5 -0.5v-5a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10a2 2 0 0 0 1.83 -1.2 0.51 0.51 0 0 1 0.46 -0.3h3.21a1.5 1.5 0 0 0 0 -3h-5a2 2 0 0 0 -1.83 1.2 0.51 0.51 0 0 1 -0.46 0.3H4.5A3.5 3.5 0 0 0 1 10.5v0.75a0.75 0.75 0 0 0 1.5 0v-0.75A0.5 0.5 0 0 1 3 10Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5h1.5a1.5 1.5 0 0 0 0 -3H18a1.5 1.5 0 0 0 0 3Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmokingAndVaping);
export default ForwardRef;